import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { SellingCompanyCountry } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SellingCompanyCountryService extends TmsWebBaseEditCreateService<
  SellingCompanyCountry,
  SellingCompanyCountry
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SellingCompanyCountry', $localize`Selling Company Country`);
  }

  getForSellingCompany(id: string): Observable<SellingCompanyCountry[]> {
    return this.httpService.get<SellingCompanyCountry[]>(`${this.apiUrl}/GetForSellingCompany?id=${id}`);
  }
}
